import { createBrowserRouter, type RouteObject } from 'react-router-dom';
import { RootLayout } from './layouts/RootLayout';
import { AuthLayout } from './layouts/AuthLayout';
import { DashboardPage } from './pages/DashboardPage';
import { AppsPage } from './pages/AppsPage';
import { WorkflowsPage } from './pages/WorkflowsPage';
import { DataModelerPage } from './pages/DataModelerPage';
import { FormBuilderPage } from './pages/FormBuilderPage';
import { SettingsPage } from './pages/SettingsPage';
import { AdminPage } from './pages/admin/AdminPage';
import { LoginPage } from './pages/LoginPage';
import { MagicLinkPage } from './pages/MagicLinkPage';

const routes: RouteObject[] = [
  // Auth routes (public)
  {
    path: '/login',
    element: <LoginPage />,
  },
  {
    path: '/auth/magic-link',
    element: <MagicLinkPage />,
  },
  // Protected routes
  {
    path: '/',
    element: <AuthLayout><RootLayout /></AuthLayout>,
    children: [
      {
        index: true,
        element: <DashboardPage />,
      },
      {
        path: 'apps',
        element: <AppsPage />,
      },
      {
        path: 'apps/:appId',
        lazy: () => import('./pages/AppDetailPage'),
      },
      {
        path: 'workflows',
        element: <WorkflowsPage />,
      },
      {
        path: 'workflows/:workflowId',
        lazy: () => import('./pages/WorkflowDesignerPage'),
      },
      {
        path: 'data',
        element: <DataModelerPage />,
      },
      {
        path: 'forms',
        element: <FormBuilderPage />,
      },
      {
        path: 'settings',
        element: <SettingsPage />,
      },
      {
        path: 'admin',
        element: <AdminPage />,
      },
    ],
  },
];

export const router: ReturnType<typeof createBrowserRouter> = createBrowserRouter(routes);
